export default "__VITE_ASSET__618a5e47__"